/*
 * 勤務表のファイル取込の、画面の文の置き場（2026-10-11、W-6）。
 *
 * ■ ［標準TSVをダウンロード］のそばに出す説明
 *
 * 文は Gemini が決めたもの（2026-10-11、T1）。言い回しを変えない。
 * 空にすると、画面には何も出ない。
 *
 * ■ 伝えている事実
 *
 * ダウンロードされるのは、見出しとその月の日付だけが入った、記入用の空の表。開始時刻・
 * 終了時刻などを記入してから［ファイルを選択］で取り込む。何も記入せずにそのまま取り込むと、
 * 入れる値が無いので「反映できるデータがありません。」になる（実機で、見本だと思って
 * そのまま取り込み、エラー1件・反映0日になった）。
 */
export const ROSTER_TEMPLATE_NOTE = '日付のみが入った入力用のファイルです。勤務時間などを記入してから取り込んでください。'
